<template>
    <div class="postDetails spackage padding-20 bgc box-shadow">
        <div class="issueContent">
            <!--上面操作-->
            <div class="postDet_wrap">
                <div class="title"><span>帖子详情</span></div>
                <div class="postDet_main">
                    <div class="postTop">
                        <span class="postTitle">发帖人信息：</span>
                        <div class="postInfo">
                            <img :src="customerlogo" alt="">
                            <div>
                                <p style="margin-bottom: 10px">{{customername}}</p>
                                <p>{{datetime}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="postBottom">
                        <div v-show="subject" style="padding-top: 30px">
                            <span class="postTitle">帖子标题:</span>
                            <span>{{subject}}</span>
                        </div>
                        <div style="margin-top: 20px">
                            <span class="postTitle">帖子详情:</span>
                            <span class="color">
                                <!--扫码查看帖子详情-->
                                <el-popover placement="bottom" width="200" trigger="click">
                                <img :src="postDet_img" alt="qrcode">
                                <sppan slot="reference" @click="popoverimg = getCode(url)">扫码查看帖子详情</sppan>
                                </el-popover>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pl">
                <div class="title"><span>用户评论</span></div>
                <div class="pl-list">
                    <div class="pl-item">
                        <img :src="commentheadimageurl" alt="">
                        <div class="pl-content">
                            <p class="pl-title">
                                <span>{{commentcustomername}}</span>
                                <span>{{commentdatetime}}</span>
                            </p>
                            <p class="pl-text">{{commentcontent}}</p>
                        </div>
                        <div class="pl-reply_style" @click="hfClick(commentcustomername)">回复</div>

                        <div class="pl-item" v-for="item in replyList">
                            <img :src="item.replyHeadimageurl" alt="">
                            <div class="pl-content">
                                <p class="pl-title">
                                    <span>{{item.replyCustomername}}</span>回复<span>{{commentcustomername}}</span>
                                </p>
                                <p class="pl-text" style="margin-left: 10px">{{item.replyContent}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="more">
                <p style="cursor: pointer" v-if="pageinfo.pageCount > pllistData.page" @click="clickpage">点击加载更多 <i class="el-icon-d-arrow-right"></i></p>
                <p v-if="pageloading == true">加载中...</p>
                <template v-if="pageinfo.pageCount > 1 && pageloading == false">
                    <p v-if="pageinfo.pageCount === pllistData.page || pageinfo.pageCount < pllistData.page">没有更多了</p>
                </template>
            </div>
        </div>
        <el-dialog title="回复" :visible.sync="dialogVisible">
            <el-input type="textarea" v-model="commentMain" :placeholder="'回复  '+ commentName +' 的评论，不超过100个字'"
                      clearable maxlength="100" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitdialog">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getCommentDetails, saveReplyInfo} from 'api/communityApi'
    import {urlToQRCode} from 'common/js/tools'
    export default {
        name: "commentDetails",
        data() {
            return {
                postDet_img:'',
                dialogVisible: false,
                mlist: [
                    {label: '使用马甲', value: 1},
                    {label: '不使用马甲', value: 0}
                ],
                form: {
                    content: '',
                    majia: 0
                },
                cominnerid: '',
                customerlogo: '',
                customername: '',
                datetime: '',
                subject: '',
                contents: '',
                url: '',
                commentName: '', //回复人
                commentMain: '', //回复内容
                replyList: [], //回复列表
                //  以下是评论（评论人）信息
                commentheadimageurl: '',
                commentcustomername: '',
                commentdatetime: '',
                commentcontent: '',
                // 以下是分页信息
                pllistData: {
                    page: 1
                },
                pageinfo: {},    // 页数
                pageloading: false, // 点击加载
            }
        },
        mounted() {
            this.pllist(1);
        },
        methods: {
            getCode(code){
                this.postDet_img = urlToQRCode(code);
            },
            // 获取评论详情
            pllist(page) {
                this.pllistData = {
                    starinnerid: this.$route.query.starinnerid,
                    contentinnerid: this.$route.query.innerid,
                    sourceinnerid: this.$route.query.sourceinnerid,
                    // page: page || this.pllistData.page,
                    // page: this.pllistData.page,
                    page: page==1?page:this.pllistData.page,
                    pageSize: 10
                };
                getCommentDetails({
                    data: this.pllistData,
                    success: data => {
                        console.log(data);
                        this.pageinfo = data.data.pageinfo;
                        this.cominnerid = data.data.cominnerid;
                        this.customerlogo = data.data.customerlogo;
                        this.customername = data.data.customername;
                        this.datetime = data.data.datetime;
                        this.subject = data.data.subject; //帖子标题
                        this.contents = data.data.contents; //评论内容
                        this.url = data.data.url; //帖子标题
                        // this.replyList =  data.data.pageinfo.pageNum>1?this.replyList.concat(data.data.content):data.data.content //回复列表
                        this.replyList = page>1?this.replyList.concat(data.data.content):data.data.content; //回复列表
                        // 以下是评论（评论人）列表
                        this.commentheadimageurl = data.data.commentheadimageurl;
                        this.commentcustomername = data.data.commentcustomername;
                        this.commentdatetime = data.data.commentdatetime;
                        this.commentcontent = data.data.commentcontent;
                        this.pageloading = false;
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 回复
            hfClick(name) {
                this.dialogVisible = true;
                this.commentName = name;
                this.commentMain = '';
            },
            submitdialog() {
                let params = {
                    commentid: this.$route.query.innerid,
                    content: this.commentMain
                };
                console.log(params);
                saveReplyInfo({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.dialogVisible = false;
                        this.$message({type: 'success', message: '回复成功！'});
                        // this.pllist(this.pllistData)
                        this.pllist(1)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // 分页
            clickpage() {
                this.pllistData.page += 1;
                this.pageloading = true;
                // this.setLoading(true);
                this.pllist()
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    .postDetails {
        .title {
            padding-left: 8px;
            border-left: solid 2px #409EFF;
            span {
                font-size: 16px;
                font-weight: bold;
                color: #303133;
            }
        }
        .postDet_wrap .title {
            color: #409EFF;
            font-size: 16px;
            margin-bottom: 20px;
            span {
                color: #303133;
                font-weight: 700;
                position: relative;
                top: 2px;
            }
        }
        .issueContent {
            width: 840px;
        }
        .postDet_main {
            width: 800px;
            height: auto;
            padding: 20px;
            background: rgba(245, 247, 250, 1);
            position: relative;
            .postTitle {
                width: 100px;
                display: inline-block;
                color: #303133;
            }
            .postTop {
                padding-bottom: 20px;
                border-bottom: 1px solid #DCDFE6;
                .postInfo {
                    display: flex;
                    align-items: center;
                    img {
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        background: #eee;
                        display: inline-block;
                        margin-right: 10px;
                    }
                }
            }
            .postBottom {
                display: block !important;
            }
            .color {
                color: #409eff;
            }
        }
        .postDet_main > div {
            display: flex;
            align-items: center;
        }
        .position {
            span {
                color: #409eff;
                margin-right: 10px;
                cursor: pointer;
            }
        }
        .pl {
            margin-top: 38px;
            width: 840px;
            .el-dropdown {
                position: absolute;
                right: 0;
                width: 30px;
                height: 10px;
                line-height: 10px;
                .el-dropdown-menu {
                    width: 100px;
                }
                .el-dropdown-link {
                    cursor: pointer;
                    color: #409EFF;
                }
            }

            .pl-item {
                display: block;
                position: relative;
                width: 100%;
                padding: 20px 0;
                flex-wrap: nowrap;
                align-content: flex-start;
                border-bottom: solid 1px #DCDFE6;
                overflow: hidden;

                img {
                    float: left;
                    margin-right: 8px;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: #ccc;
                }
                .pl-content {
                    float: left;
                    max-width: 630px;
                    .pl-title {
                        span {
                            display: inline-block;
                            margin-right: 20px;
                        }
                        span:last-child {
                            font-size: 14px;
                            color: #C0C4CC;
                        }
                        span:first-child {
                            font-size: 16px;
                            color: #303133;
                        }
                    }
                    .pl-text {
                        margin-top: 10px;
                        font-size: 14px;
                        color: #909399;
                        line-height: 20px;
                    }
                }

                .pl-item {
                    padding-left: 60px;
                    box-sizing: border-box;
                    .el-dropdown {
                        line-height: 30px;
                    }
                    img {
                        width: 30px;
                        height: 30px;
                        margin-right: 0;
                    }

                    .pl-title {
                        line-height: 30px;
                        span {
                            padding: 0;
                            margin: 0 10px;
                            font-size: 16px !important;
                            color: #409EFF !important;
                        }
                    }

                }
                .pl-item:last-child {
                    border: none;
                }

            }
        }
        .more {
            margin-top: 15px;
            width: 840px;
            text-align: center;
            span {
                font-size: 13px;
                color: #606266;
            }
            i {
                -webkit-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -o-transform: rotate(90deg);
                transform: rotate(90deg);
            }
        }
    }

    .pl-reply_style {
        position: absolute;
        right: 0;
        width: 30px;
        height: 10px;
        color: #409EFF;
        cursor: pointer;
    }

</style>
